var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 7.49984C1.66797 5.92817 1.66797 5.14317 2.1563 4.65484C2.64464 4.1665 3.42964 4.1665 5.0013 4.1665H15.0013C16.573 4.1665 17.358 4.1665 17.8463 4.65484C18.3346 5.14317 18.3346 5.92817 18.3346 7.49984C18.3346 7.89234 18.3346 8.089 18.213 8.2115C18.0905 8.33317 17.893 8.33317 17.5013 8.33317H2.5013C2.1088 8.33317 1.91214 8.33317 1.78964 8.2115C1.66797 8.089 1.66797 7.8915 1.66797 7.49984ZM1.66797 14.9998C1.66797 16.5715 1.66797 17.3565 2.1563 17.8448C2.64464 18.3332 3.42964 18.3332 5.0013 18.3332H15.0013C16.573 18.3332 17.358 18.3332 17.8463 17.8448C18.3346 17.3565 18.3346 16.5715 18.3346 14.9998V10.8332C18.3346 10.4407 18.3346 10.244 18.213 10.1215C18.0905 9.99984 17.893 9.99984 17.5013 9.99984H2.5013C2.1088 9.99984 1.91214 9.99984 1.78964 10.1215C1.66797 10.244 1.66797 10.4415 1.66797 10.8332V14.9998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83594 2.5V5M14.1693 2.5V5",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4b6ac86e2b7b5ec76f51d7f5b1e5f10d.svg";
export { ForwardRef as ReactComponent };